function getFullAddress(place) {
    let address1;
    let locality;
    let adminArea1Short;
    let adminArea1Long;
    let adminArea2Short;
    let adminArea2Long;
    let countryShort;
    let countryLong;
    let apartmentNumber;
    let postalCode = '';
    let postalCodeExtension;
    let sublocality;
    const formattedAddress = place.formatted_address;
    const latitude = place.geometry?.location?.lat();
    const longitude = place.geometry?.location?.lng();
    // Get each component of the address from the place details,
    place.address_components?.forEach((component) => {
        component.types.forEach((componentType) => {
            if (componentType === 'street_number') {
                address1 = component.long_name;
            }
            if (componentType === 'route') {
                address1 = `${address1 === undefined ? '' : address1} ${component.long_name}`;
            }
            if (componentType === 'locality') {
                locality = component.long_name;
            }
            if (componentType === 'administrative_area_level_1') {
                adminArea1Short = component.short_name;
                adminArea1Long = component.long_name;
            }
            if (componentType === 'administrative_area_level_2') {
                adminArea2Short = component.short_name;
                adminArea2Long = component.long_name;
            }
            if (componentType === 'postal_code') {
                postalCode = component.long_name;
            }
            if (componentType === 'postal_code_suffix') {
                postalCodeExtension = component.long_name;
            }
            if (componentType === 'country') {
                countryShort = component.short_name;
                countryLong = component.long_name;
            }
            if (componentType === 'subpremise') {
                apartmentNumber = component.long_name;
            }
            if (componentType === 'sublocality_level_1') {
                sublocality = component.long_name;
            }
        });
    });
    const resAddress = {
        address1,
        locality,
        adminArea1Short,
        adminArea1Long,
        adminArea2Short,
        adminArea2Long,
        postalCode,
        postalCodeExtension,
        countryShort,
        countryLong,
        apartmentNumber,
        latitude,
        longitude,
        sublocality,
        formattedAddress,
    };
    return resAddress;
}
function generateGoogleMapsAddress(addressObj) {
    if (addressObj.formattedAddress) {
        return addressObj.formattedAddress;
    }
    // console.log('Address : ', addressObj);
    // Function to handle undefined values
    function formatValue(value) {
        return value !== undefined ? value : '';
    }
    // Create the address string
    let addressString = '';
    if (addressObj.address1) {
        addressString += formatValue(addressObj.address1);
    }
    if (addressObj.apartmentNumber) {
        addressString += `, ${formatValue(addressObj.apartmentNumber)}`;
    }
    if (addressObj.locality) {
        if (addressString.length > 0) {
            addressString += ', ';
        }
        addressString += formatValue(addressObj.locality);
    }
    else if (addressObj.sublocality) {
        if (addressString.length > 0) {
            addressString += ', ';
        }
        addressString += formatValue(addressObj.sublocality);
    }
    if (addressObj.adminArea1Short) {
        addressString += `, ${formatValue(addressObj.adminArea1Short)}`;
    }
    if (addressObj.postalCode) {
        addressString += ` ${formatValue(addressObj.postalCode)}`;
    }
    if (addressObj.countryLong) {
        addressString += `, ${formatValue(addressObj.countryLong)}`;
    }
    return addressString;
}
function generateCityStateZipString(addressObj) {
    const { locality, adminArea1Short, postalCode } = addressObj;
    const localityPart = locality ? `${locality}` : '';
    const adminAreaPart = adminArea1Short ? `${locality ? ', ' : ''}${adminArea1Short}` : '';
    const postalCodePart = postalCode ? ` ${postalCode}` : '';
    return `${localityPart}${adminAreaPart}${postalCodePart}`.trim();
}
function fullAddressToString(addressObj) {
    const street = addressObj.address1 ? addressObj.address1 : '';
    const secondary = addressObj.apartmentNumber ? addressObj.apartmentNumber : '';
    const city = addressObj.locality
        ? addressObj.locality
        : addressObj.sublocality
            ? addressObj.sublocality
            : '';
    const state = addressObj.adminArea1Short ? addressObj.adminArea1Short.replace(/,$/, '') : '';
    const zip = addressObj.postalCode ? addressObj.postalCode : '';
    // These are combined because a formatted address string has no comma between them
    const stateAndZip = zip && state ? `${state} ${zip}` : zip || state;
    return [street, secondary, city, stateAndZip].filter(Boolean).join(', ');
}
function addressToString(addressObj) {
    const street = addressObj.addressLineOne ? addressObj.addressLineOne : '';
    const secondary = addressObj.addressLineTwo ? addressObj.addressLineTwo : '';
    const city = addressObj.city ? addressObj.city : '';
    const state = addressObj.state ? addressObj.state.replace(/,$/, '') : '';
    const zip = addressObj.zipBase ? addressObj.zipBase : addressObj.zip ? addressObj.zip : '';
    // These are combined because a formatted address string has no comma between them
    const stateAndZip = zip && state ? `${state} ${zip}` : zip || state;
    return [street, secondary, city, stateAndZip].filter(Boolean).join(', ');
}

export { addressToString, fullAddressToString, generateCityStateZipString, generateGoogleMapsAddress, getFullAddress };
//# sourceMappingURL=address_utils.js.map
